import React, { useEffect, useState, forwardRef, useRef } from "react";
import {
  substract_icon,
  add_icon,
  icon_trash,
  check,
  close,
  close_icon,
  weight_icon,
  AddPackage,
  Replace,
} from "../../../assets";
import { useTranslation } from "react-i18next";
import QuantityModal from "../../Modal/Quantity_Modal";
import LooseQuantityModal from "../../Modal/LooseQuantity_Modal";
import { useDispatch, useSelector } from "react-redux";
import PasswordModal from "../../Modal/Password_Modal";
import {
  verifyPassowrd,
  verifyPassword,
} from "../../../API/API Functions/ProductRequest_API";
import { toast } from "react-toastify";
import { detectWebDeviceType, isTablet } from "../../../utils";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import PackageItems from "./PackageItems";
import { addProducts } from "../../../Redux/Action/productsAction";
import dummy_image from "../../../assets/no-image.webp";
import { info_icon } from "../../../assets";
import HamperInfoModal from "../../Modal/HamperInfoModal";
import EditSPModal from "../../Modal/EditSPmodal";
import AlphaNumericKeyboardModal from "../../Modal/AlphaNumericKeyboardModal";
import ProductExpiryModal from "../../Modal/ProductExpiryModal";

const LoadingSpinner = () => {
  return (
    <div
      style={{ zIndex: 100 }}
      className="fixed top-0 left-0 w-full h-full z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur"
    >
      <div className="spinner">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};

const LOOSE_UOMS = ["KG", "Kg", "kg", "كجم", "Meter", "Liter", "متر"];

const ProductCart = forwardRef(
  (
    {
      product,
      onDelete,
      onUpdateQuantity,
      onUpdateDiscount,
      isSelected,
      isScannerActive,
      userSelectedIndex,
      addGroupProductModal,
      groupModal,
      onUpdateSP,
    },
    ref,
  ) => {
    const [quantity, setQuantity] = useState(product.quantity);
    const { t, i18n } = useTranslation();
    const deviceType = detectWebDeviceType();
    const dispatch = useDispatch();
    const [productExpiryModal, setProductExpiryModal] = useState(false)

    const mapDiscountType = (type) => {
      if (type === "fixed") return "value";
      return type || "";
    };

    const [tempQuantity, setTempQuantity] = useState(product.quantity); // Temporary quantity for popover
    const [isPopoverVisible, setPopoverVisible] = useState(false); // Popover visibility state
    const [activePopover, setActivePopover] = useState(null); // Track the active popover by product ID
    const isArabic = i18n.language === "ar";
    const [isModalVisible, setModalVisible] = useState(false);
    const [openPassword, setOpenPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openInfoModal, setOpenInfoModal] = useState(false);
    const [editSPModalVisible, seShowEditSPModalVisible] = useState(false);
    const [promotion, setPromotion] = useState(null)
    const [editedSP, setEditedSP] = useState("");
    const requiredPass = useSelector(
      (state) => state?.permissionReducer?.permissions?.is_password_restrict,
    );

    const groupModalOpen = useSelector(
      (state) => state?.groupModalOpen?.groupModalOpen,
    );

    const userData = useSelector((state) => state?.login?.user?.result);
    const [qtyMode, setQtyMode] = useState("");
    const [inputNewQuantity, setInputNewQuantity] = useState("");
    const [packages, setPackageData] = useState([]);
    const [isOpenReplacePackageModal, setIsOpenReplacePackageModal] =
      useState(false);
    const [isOpenAddPackageModal, setIsOpenAddPackageModal] = useState(false);
    const closePasswordModal = () => setOpenPassword(false);
    const localProducts = useSelector((state) => state.products.products);
    // console.log('localProducts',localProducts);

    const returnProducts = useSelector(
      (state) => state.returnProductReducer.products,
    );
    const productArray = Object.values(localProducts);
    const returnArray = Object.values(returnProducts || []).map((p) => ({
      ...p,
      isReturn: true,
    }));
    const allProducts = [...productArray, ...returnArray];
    const inputRef = useRef(null);

    const allowDscount = useSelector(
      (state) => state?.permissionReducer?.permissions?.is_allow_discount,
    );

    const negativeSale = useSelector(
      (state) => state?.permissionReducer?.permissions?.is_allow_negative_sale,
    );
    const isETAenabled = useSelector(
      (state) => state?.permissionReducer?.permissions?.is_eta_enabled,
    );

    const isAllowUpdateSP = useSelector(
      (state) => state?.permissionReducer?.permissions?.is_allow_sale_price_edit,
    );
    const [discountType, setDiscountType] = useState(mapDiscountType(product.promotion?.promotion?.discount_type) || "");
    const [discountValue, setDiscountValue] = useState(product.promotion?.promotion?.discount_value ?? "");

    useEffect(() => {
      setQuantity(product.quantity);
    }, [product.quantity]);

    useEffect(() => {
      if (!product.promotion?.promotion) {
        setDiscountType(product.discount_type || "");
        setDiscountValue(product.discount_value ?? "");
      }
    }, [product.sale_price]);

    // AFTER
    useEffect(() => {
      const promo = product?.promotion?.promotion;
      if (promo && isPromotionActive(promo)) {
        setPromotion(promo);
        setDiscountType(mapDiscountType(promo.discount_type) || "");
        setDiscountValue(promo.discount_value ?? "");
      } else {
        setPromotion(null);
        setDiscountType("");
        setDiscountValue("");
      }
    }, [product.promotion]);

    useEffect(() => {
      const promo = product?.promotion?.promotion;
      if (!promo?.end_date) return;

      if (!isPromotionActive(promo)) return; // already handled by the effect above

      const nowEgyptDate = new Date(getEgyptNowString().replace(" ", "T"));
      const endDate = new Date(promo.end_date.replace(" ", "T"));
      const msUntilExpiry = endDate - nowEgyptDate;

      if (msUntilExpiry <= 0) return;

      const timer = setTimeout(() => {
        setPromotion(null);
        setDiscountType("");
        setDiscountValue("");
      }, msUntilExpiry + 500); // small buffer past the boundary

      return () => clearTimeout(timer);
    }, [product.promotion]);

    const handlePasswordConfirm = async (enteredPassword) => {
      setLoading(true);
      const userId = userData?.user_id;
      const action = "Decreased product quantity";
      try {
        const verificationResult = await verifyPassword(
          userId,
          enteredPassword,
          action,
        );

        if (
          verificationResult &&
          verificationResult?.result?.status_code === 200
        ) {
          if (qtyMode === "decrease") {
            decreaseQuantity();
            closePasswordModal();
            setLoading(false);
          } else {
            handleConfirm(inputNewQuantity);
            closePasswordModal();
            setLoading(false);
          }
        } else if (verificationResult?.result?.status_code === 400) {
          toast.error(t("Incorrect password"));
          setLoading(false);
          return;
        }
      } catch (error) {
        console.error("Error verifying password:", error);
      }
    };



    const decreaseQuantity = () => {
      if (quantity > 1) {
        const newQuantity = Number((quantity - 1).toFixed(3));

        setQuantity(newQuantity);
        setDiscountValue("");
        onUpdateQuantity(product, newQuantity);
      }
    };
    const handleDecreaseClick = () => {
      if (requiredPass === true) {
        setOpenPassword(true);
        setQtyMode("decrease");
      } else {
        decreaseQuantity();
      }
    };

    const increaseQuantity = () => {
      const newQuantity = quantity + 1;
      // console.log("NEWWW", newQuantity);
      // console.log("OLDDD", product?.qty_available);

      if (!negativeSale && newQuantity > product?.qty_available) {
        toast.error(t("Negative sale is not allowed"));
        return;
      }
      setQuantity(newQuantity);
      // setDiscountValue("");
      onUpdateQuantity(product, newQuantity);
    };

    const handleInputChange = (e) => {
      let value = e.target.value;
      // Ensure the input does not start with more than one zero
      if (value.startsWith("00")) {
        value = "0";
      }
      if (value.length > 4) {
        value = value.slice(0, 4);
      }
      if (value === "" || (value.match(/^\d*$/) && Number(value) < 10000)) {
        const qty = value === "" ? 0 : Number(value);
        if (qty < quantity) {
          setDiscountValue("");
        }
        setQuantity(qty);
        onUpdateQuantity(product, qty);
        // setIsEdited(true);
      }
    };
    // console.log("CLICKKKaddGroupProductModal", groupModalOpen);

    const [activePopoverProduct, setActivePopoverProduct] = useState(false);

    useEffect(() => {
      if (activePopoverProduct == true) {
        setActivePopover(null);
      }
    }, [activePopoverProduct]);

    const handleKeyDown = (e) => {
      if (isSelected && !product.isReturn) {
        if (e.key === "=") {
          e.preventDefault();
          increaseQuantity();
        } else if (e.key === "-") {
          e.preventDefault();
          if (quantity > 1) {
            handleDecreaseClick();
          }
        } else if (
          e.ctrlKey &&
          e.key.toLowerCase() === "e" &&
          groupModalOpen === false
        ) {
          e.preventDefault();
          handleProductClick();
        } else if (e.key === "Escape") {
          e.preventDefault();
          handleCancel();
          setActivePopoverProduct(false);
        }
      }
    };

    useEffect(() => {
      window.addEventListener("keydown", handleKeyDown);

      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [isSelected, quantity, activePopoverProduct, groupModalOpen]);

    useEffect(() => {
      if (!isSelected) {
        setActivePopover(null);
      }
    }, [isSelected]);

    const handleQtyCheck = (newQuantity) => {
      // console.log("PPRRRRR--->", product);

      if (!negativeSale && newQuantity > product?.qty_available) {
        toast.error(t("Negative sale is not allowed"));
        return;
      }

      if (
        newQuantity < quantity &&
        (product.uom === "Units" || product.uom === "الوحدات") &&
        requiredPass === true
      ) {
        setOpenPassword(true);
        setQtyMode("input");
        setInputNewQuantity(newQuantity);
      } else {
        handleConfirm(newQuantity);
      }
    };

    const handleConfirm = (newQuantity, productId) => {
      if (newQuantity === 0) {
        newQuantity = 1;
      }
      if (newQuantity < quantity) {
        setDiscountValue("");
      }
      setQuantity((prevQuantity) =>
        productId === product.prod_id ? newQuantity : prevQuantity,
      ); // Update only the relevant product
      onUpdateQuantity(product, newQuantity);
      setModalVisible(false);
    };

    const handleCancel = () => {
      setModalVisible(false);
    };

    const getEgyptNowString = () => {
      const formatter = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Africa/Cairo",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      const parts = formatter.formatToParts(new Date());
      const map = {};
      parts.forEach(({ type, value }) => (map[type] = value));
      const hour = map.hour === "24" ? "00" : map.hour; // Intl quirk guard
      return `${map.year}-${map.month}-${map.day} ${hour}:${map.minute}:${map.second}`;
    };

    const isPromotionActive = (promo) => {
      if (!promo) return false;
      const nowEgypt = getEgyptNowString(); // "YYYY-MM-DD HH:mm:ss"
      if (promo.start_date && nowEgypt < promo.start_date) return false; // not started yet
      if (promo.end_date && nowEgypt > promo.end_date) return false; // expired
      return true;
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          !event.target.closest(".popover") &&
          !event.target.closest(".popover-check-button") &&
          !event.target.closest(".loose-popover")
        ) {
          setActivePopover(null);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [activePopover]);

    const handleInput = (e) => {
      const value = e.target.value;
      let newValue = value.replace(/[^\d.]/g, "").replace(/\.(.*)\./g, ".$1");
      const decimalSplit = newValue.split(".");
      if (decimalSplit.length > 1 && decimalSplit[1].length > 3) {
        newValue = decimalSplit[0] + "." + decimalSplit[1].slice(0, 3);
      }
      e.target.value = newValue;
      setTempQuantity(newValue);
      if (newValue === "") {
        setTempQuantity(0);
      } else {
        const floatValue = parseFloat(newValue);
        if (floatValue < 10000) {
          setTempQuantity(floatValue);
        }
      }
    };

    useEffect(() => {
      if (isSelected && inputRef.current) {
        inputRef.current.focus();
      }
    }, [isSelected]);

    const handleProductClick = (product) => {
      // setActivePopover(product.prod_id);
      setModalVisible(true);
    };

    const GetPackages = async (isAdd) => {
      if (isAdd) {
        setIsOpenAddPackageModal(true);
      } else {
        setIsOpenReplacePackageModal(true);
      }
    };

    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.ctrlKey && event.key === "ArrowRight") {
          handleRightArrowPress(allProducts);
          setDiscountValue("");
          setDiscountType("");
        } else if (event.ctrlKey && event.key === "ArrowLeft") {
          handleLeftArrowPress(allProducts);
          setDiscountValue("");
          setDiscountType("");
        }
      };
      if (isSelected && product?.is_package) {
        window.addEventListener("keydown", handleKeyDown);
      }
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [product, isSelected, allProducts]);

    const handleRightArrowPress = (allItems) => {
      const packages = product?.packages || [];
      if (packages.length === 0) return;

      // const allProducts = [...productArray, ...returnArray];
      // console.log("a;lll==>",allProducts);

      let currentIndex = -1;

      if (product.pack_id) {
        currentIndex = packages.findIndex((p) => p.pack_id === product.pack_id);
      }

      let attempts = 0;
      let nextPackage = null;

      while (attempts < packages.length) {
        const nextIndex = (currentIndex + 1) % packages.length;
        const candidate = packages[nextIndex];
        // console.log('CHECK allProducts', allItems);

        const isAlreadyAdded = allItems.some(
          (p) =>
            p.pack_id && candidate.pack_id && p.pack_id === candidate.pack_id,
        );
        // console.log('isAlreadyAdded', isAlreadyAdded);

        if (!isAlreadyAdded) {
          nextPackage = candidate;
          break;
        }

        currentIndex = nextIndex;
        attempts++;
      }

      if (nextPackage) {
        ReplaceItem(nextPackage);
      } else {
        toast.error(t("All packages already added"));
      }
    };

    // Handle left arrow (previous package)
    const handleLeftArrowPress = (allItems) => {
      const packages = product?.packages || [];
      if (packages.length === 0) return;

      // const allProducts = [...productArray, ...returnArray];

      let currentIndex = -1;

      if (product.pack_id) {
        currentIndex = packages.findIndex((p) => p.pack_id === product.pack_id);
      }

      let attempts = 0;
      let nextPackage = null;

      while (attempts < packages.length) {
        const nextIndex =
          (currentIndex - 1 + packages.length) % packages.length;
        const candidate = packages[nextIndex];

        const isAlreadyAdded = allItems.some(
          (p) =>
            p.pack_id && candidate.pack_id && p.pack_id === candidate.pack_id,
        );

        if (!isAlreadyAdded) {
          nextPackage = candidate;
          break;
        }

        currentIndex = nextIndex;
        attempts++;
      }

      if (nextPackage) {
        ReplaceItem(nextPackage);
      } else {
        toast.error(t("All packages already added"));
      }
    };

    const ReplaceItem = (item) => {
      const isAlreadyAdded = allProducts.some(
        (p) => p.pack_id && item.pack_id && p.pack_id === item.pack_id,
      );

      if (isAlreadyAdded) {
        toast.error(t("Pack already added"));
        return;
      }

      // Find the product to be replaced using both prod_id and pack_id
      const targetIndex = allProducts.findIndex(
        (p) =>
          p.prod_id === product.prod_id &&
          (product.pack_id ? p.pack_id === product.pack_id : !p.pack_id),
      );

      if (targetIndex === -1) {
        console.warn("Product not found to replace.");
        return;
      }

      // Clone and update
      const updatedProducts = [...allProducts];
      updatedProducts[targetIndex] = {
        ...updatedProducts[targetIndex],
        name: item.product_name,
        sale_price: item.pack_price,
        pack_price: item.pack_price,
        pack_id: item.pack_id,
        pack_qty: item.pack_qty,
        barcode: item.secondary_barcode
          ? item.secondary_barcode
          : product?.barcode,
        packages: product?.packages,
      };

      dispatch(addProducts(updatedProducts));
    };
    const productTax = product?.vat_details;
    const totalProductTax =
      ((product.uom == "KG" && product.is_selling_gram
        ? product?.sale_price / 1000
        : product?.sale_price) *
        productTax?.tax_rate_percent) /
      100;

    const unitPrice =
      product?.is_package && product?.pack_id
        ? product.pack_price +
        (productTax?.tax_id &&
          productTax?.is_tax_price_inclusive == false &&
          isETAenabled
          ? totalProductTax
          : 0)
        : (product.uom == "KG" && product.is_selling_gram
          ? product?.sale_price / 1000
          : product?.sale_price) +
        (productTax?.tax_id &&
          productTax?.is_tax_price_inclusive == false &&
          isETAenabled
          ? totalProductTax
          : 0);

    const discountAmount =
      discountType === "percentage"
        ? (unitPrice * (Number(discountValue) || 0)) / 100
        : Number(discountValue / (quantity || 1)) || 0;

    const priceAfterDiscount = Math.max(unitPrice - discountAmount, 0);

    const totalAfterDiscount = (priceAfterDiscount * quantity).toFixed(2);

    useEffect(() => {
      if (typeof onUpdateDiscount === "function") {
        let discount =
          discountType === "percentage"
            ? discountValue
            : Number(discountValue / (quantity || 1)) || 0;

        onUpdateDiscount(product, {
          discountType,
          discountValue: discount,
          priceAfterDiscount,
        });
      }
    }, [discountType, discountValue, priceAfterDiscount]);

    const openProductInfo = () => {
      setOpenInfoModal(true);
    };

    return (
      <>
        {loading && <LoadingSpinner />}
        <HamperInfoModal
          open={openInfoModal}
          selectedHamper={product}
          onClose={() => setOpenInfoModal(false)}
          addHamper={increaseQuantity}
        />
        {openPassword === true && (
          <PasswordModal
            onCancel={closePasswordModal}
            onConfirm={handlePasswordConfirm}
          // onCancel={setOpenPassword(false)}
          />
        )}
        {
          productExpiryModal === true && (
            <ProductExpiryModal
              open={productExpiryModal}
              onClose={() => setProductExpiryModal(false)}
              id={product?.prod_id}
            />
          )
        }
        <div
          ref={ref}
          className={`flex items-center p-3 text-base border border-solid justify-between border-slate-200 ${isSelected ? "bg-blue-100" : ""
            }`}
        >
          <div
            className={`${deviceType == "tablet" ? "w-1/2" : "w-7/12"} flex items-center gap-3.5 self-stretch font-medium text-zinc-800 cursor-pointer `}

          >
            {product?.image_url || product?.image ? (
              <img
                loading="lazy"
                src={product?.image_url || product?.image}
                alt={""}
                className={`shrink-0 aspect-square object-contain w-[40px] h-[40px] ${deviceType ? "me-2" : "me-1"
                  }`}
                onClick={() => setProductExpiryModal(true)}
              />
            ) : (
              <img
                loading="lazy"
                src={dummy_image}
                alt={""}
                className={`shrink-0 aspect-square object-contain w-[40px] h-[40px] ${deviceType ? "me-2" : "me-1"
                  }`}
                  onClick={() => setProductExpiryModal(true)}
              />
            )}
            <div className="flex flex-col" >
              {product.isReturn ? (
                <div
                  className={`font-semibold text-neutral-700 break-words whitespace-normal ${deviceType ? "max-w-[300px]" : ""
                    }`}
                >
                  {product?.name}
                </div>
              ) : (
                <div
                  className={`font-semibold text-neutral-700 break-words whitespace-normal ${deviceType ? "max-w-[300px]" : ""
                    }` } onClick={() => setProductExpiryModal(true)}
                >
                  {product?.name}{" "}
                  {product?.pack_id
                    ? ` : ${t("Pack of")} ${product.pack_qty}`
                    : ""}
                </div>
              )}

              <div className="my-auto text-zinc-800 text-opacity-70 font-semibold flex items-center gap-2">
                {"EGP "}{" "}
                {(product?.is_package && product?.pack_id
                  ? product.pack_price
                  : product.uom == "KG" && product.is_selling_gram
                    ? product?.sale_price / 1000
                    : product?.sale_price
                )?.toFixed(2)}
                {/* Edit Button */}
                {isAllowUpdateSP && !product.isReturn &&
                  <button
                    className=" flex items-center bg-[#1b4597] px-2 py-1 my-1  text-white rounded-md font-semibold text-sm cursor-pointer"
                    onClick={() => seShowEditSPModalVisible(true)}
                  >
                    {t("Increase Sales Price")}
                  </button>
                }

                {isETAenabled && productTax?.tax_id && (
                  <span className="text-gray-400">
                    {productTax?.is_tax_price_inclusive
                      ? ` (${productTax?.tax_rate_percent}% inclusive tax)`
                      : ` (${productTax?.tax_rate_percent}% exclusive tax)`}
                  </span>
                )}
              </div>
              <div className="my-auto text-zinc-800 text-opacity-70 font-semibold">
                {product?.barcode}
              </div>
              <div className="flex items-center">
                {product?.is_package && (
                  <div
                    onClick={() => GetPackages(false)}
                    className=" flex items-center my-auto bg-[#7EC242] px-3 py-1 mt-1 text-white rounded-md font-semibold cursor-pointer"
                  >
                    {t("Sell by Pack")}
                  </div>
                )}
                {product.hamper_id && (
                  <div
                    onClick={() => openProductInfo(product)}
                    className="flex items-center my-auto bg-gray-400 px-3 py-1 mt-1 text-white rounded-md font-semibold cursor-pointer"
                  >
                    {t("Hamper Details")}
                  </div>
                )}
              </div>

              {allowDscount && !product.isReturn && !product?.hamper_id && (
                <div
                  className={`${deviceType == "tablet" ? (i18n.language === "ar" ? "-mr-16" : "-ml-16") : ""} mt-8 w-full flex flex-row items-center gap-3`}
                >
                  <span className="text-base font-semibold">
                    {t("Discount per unit")} :
                  </span>

                  <div className="flex gap-3 mt-0">
                    {/* Percentage radio */}
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        checked={discountType === "percentage"}
                        onChange={() => {
                          setDiscountType("percentage");
                          if (isPromotionActive(promotion) && mapDiscountType(promotion?.discount_type) === "percentage") {
                            setDiscountValue(promotion?.discount_value ?? "");
                          } else {
                            setDiscountValue("");
                          }
                        }}
                        className="h-5 w-5"
                      />
                      {t("Percentage")}
                    </label>

                    {/* Value radio */}
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        checked={discountType === "value"}
                        onChange={() => {
                          setDiscountType("value");
                            if (isPromotionActive(promotion) && mapDiscountType(promotion?.discount_type) === "fixed") {
                            setDiscountValue(promotion?.discount_value ?? "");
                          } else {
                            setDiscountValue("");
                          }
                        }}
                        className="h-5 w-5"
                      />
                      {t("Value")}
                    </label>
                  </div>

                  {/* Input for discount value */}
                  {discountType && (
                    <input
                      type="text" // <-- important: change from number to text to fully control input
                      value={discountValue}
                      placeholder={
                        discountType === "percentage"
                          ? t("Enter %")
                          : t("Enter amount")
                      }
                      className="border rounded px-3 py-1 mt-2 w-[150px] focus:outline-none focus:border-2px"
                      onKeyDown={(e) => {
                        // BLOCK minus sign and scientific notation like 1e5
                        if (e.key === "-" || e.key === "e" || e.key === "E") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        let value = e.target.value;

                        // Allow digits and at most one decimal
                        value = value.replace(/[^0-9.]/g, "");

                        // Prevent multiple decimals
                        value = value.replace(/(\..*)\./g, "$1");

                        // Restrict to 2 decimal places
                        if (value.includes(".")) {
                          const [intPart, decimalPart] = value.split(".");
                          if (decimalPart.length > 2) {
                            return; // block input
                          }
                        }

                        let val = parseFloat(value);
                        let numeric = 0;
                        if (discountType === "value") {
                          numeric = val / (quantity || 1);
                        } else {
                          numeric = val;
                        }
                        console.log("numericnumeric==>", numeric);
                        if (isNaN(numeric)) {
                          setDiscountValue("");
                          return;
                        }

                        const originalCostPrice =
                          product?.is_package && product?.pack_id
                            ? (product.uom == "KG" && product.is_selling_gram
                              ? product?.cost_price / 1000
                              : product?.cost_price) * product?.pack_qty
                            : product.uom == "KG" && product.is_selling_gram
                              ? product?.cost_price / 1000
                              : product?.cost_price;

                        // ---- VALUE DISCOUNT VALIDATION ----
                        if (discountType === "value") {
                          if (numeric > unitPrice - originalCostPrice) {
                            toast.error(
                              t(
                                "The Discount price cannot be less than the Cost price",
                              ),
                            );
                            return; //  block user input
                          }
                        }

                        const percentSalePrice =
                          unitPrice - (unitPrice * numeric) / 100;

                        console.log("percentSalePrice===>", percentSalePrice);

                        // ---- PERCENTAGE DISCOUNT VALIDATION ----
                        if (discountType === "percentage") {
                          if (percentSalePrice < originalCostPrice) {
                            toast.error(
                              t(
                                "The Discount price cannot be less than the Cost price",
                              ),
                            );
                            return; // block user input
                          }
                        }

                        if (discountType === "value") {
                          if (unitPrice - numeric < originalCostPrice) {
                            toast.error(
                              t(
                                "The Discount price cannot be less than the Cost price",
                              ),
                            );
                            return; //  block user input
                          }
                        }

                        setDiscountValue(value);
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center justify-center">
            <div className="flex items-center ps-8 pe-6">
              {product.isReturn ? (
                <div className="my-auto text-red-700 text-l font-semibold">
                  {/* {isArabic
                    ? ` ${t("To Refund")} ${quantity?.toFixed(2)}${product?.uom === "KG" ||
                      product?.uom === "Kg" ||
                      product?.uom === "كجم"
                      ? "KG" || "كجم" || "Kg"
                      : ""
                    }`
                    : `${t("To Refund")} : ${quantity?.toFixed(2)} ${product?.uom === "KG" ? " KG" : ""
                    }`} */}
                  {isArabic
                    ? ` ${t("To Refund")} ${quantity?.toFixed(2)} ${LOOSE_UOMS.includes(product.uom)
                      ? t(
                        product.uom == "KG" && product.is_selling_gram
                          ? t("gm")
                          : product.uom,
                      )
                      : ""
                    }`
                    : `${t("To Refund")} : ${quantity?.toFixed(2)} ${LOOSE_UOMS.includes(product.uom)
                      ? t(
                        product.uom == "KG" && product.is_selling_gram
                          ? t("gm")
                          : product.uom,
                      )
                      : ""
                    }`}
                </div>
              ) : LOOSE_UOMS.includes(product.uom) ? (
                //  product.uom === "Kg" ||
                //   product.uom == "KG" ||
                //   product.uom == "كجم" ? (
                // Show the input field for loose items (UOM KG) even if it's not a return product
                <div className="relative">

                  <div
                    className={`flex border border-solid bg-white rounded-lg w-[110px] overflow-hidden justify-center items-center ${i18n.language === "ar" ? "flex-row-reverse" : ""
                      }`}
                  >
                    <input
                      // ref={inputRef}
                      type={"text"}
                      onChange={handleInput}
                      value={String(quantity)}
                      // style={{ direction: "ltr" }}
                      style={{
                        direction: i18n.language === "ar" ? "rtl" : "ltr",
                      }}
                      maxLength={2}
                      // onClick={() => setActivePopover(product.prod_id)}
                      onClick={() => handleProductClick(product)}
                      // disabled={!!product.weight}
                      className="px-1 py-1 rounded-xl text-left border-0 border-neutral-400 border-opacity-50 text-black max-md:pr-5 max-md:max-w-full w-full focus:outline-none focus:border-1px"
                    />
                    <span className="px-1 border-l text-md text-black max-md:pe-3">
                      <span>
                        {product.uom == "KG" && product.is_selling_gram
                          ? t("gm")
                          : t(product.uom)}
                      </span>
                    </span>
                  </div>
                  {isModalVisible && (
                    <LooseQuantityModal
                      initialQuantity={quantity}
                      // onConfirm={handleConfirm}
                      onConfirm={handleQtyCheck}
                      onCancel={handleCancel}
                      product={product}
                    />
                  )}
                </div>
              ) : (
                <>
                  <button
                    onClick={handleDecreaseClick}
                    disabled={quantity <= 1}
                    style={{
                      width: "40px",
                      backgroundColor: "transparent",
                      border: "none",
                      outline: "none",
                      cursor: quantity <= 1 ? "not-allowed" : "pointer",
                      opacity: quantity <= 1 ? 0.5 : 1,
                    }}
                  >
                    <img
                      loading="lazy"
                      src={substract_icon}
                      alt="substract_icon"
                    />
                  </button>
                  <div className="relative">
                    <input
                      // ref={inputRef}
                      type="text"
                      value={quantity}
                      onChange={handleInputChange}
                      // onClick={() => setActivePopover(product.prod_id)}
                      onClick={() => handleProductClick(product)}
                      className="w-8 text-center border-0 border-neutral-400 border-opacity-50 focus:outline-none focus:border-1px whitespace-nowrap"
                      style={{ width: "3rem" }}
                      readOnly
                    />
                  </div>
                  <button
                    onClick={increaseQuantity}
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      outline: "none",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      loading="lazy"
                      src={add_icon}
                      alt="add_icon"
                      className="w-[35px] h-10"
                    />
                  </button>

                  {isModalVisible && (
                    <QuantityModal
                      initialQuantity={quantity}
                      // onConfirm={handleConfirm}
                      onConfirm={handleQtyCheck}
                      onCancel={handleCancel}
                    />
                  )}
                </>
              )}
              {/* // ) : null} */}
            </div>
            <div
              className={`flex justify-center items-center w-[45px] flex-shrink-0 ${product.isReturn ? "me-14" : "" // Add margin-end if isReturn is true
                }`}
            >
              {/* {(product?.sale_price * quantity).toFixed(2)} */}
              {/* {(((product?.is_package && product?.pack_id) ? product.pack_price : product?.sale_price) * quantity).toFixed(2)} */}
              {totalAfterDiscount}
            </div>
            {!product.isReturn && (
              <div
                onClick={() => onDelete(product)}
                className={`flex ms-5 cursor-pointer ${deviceType == "tablet" ? "w-[35px]" : "w-[30px]"
                  }`}
              >
                <img
                  loading="lazy"
                  src={icon_trash}
                  alt="trash_icon"
                  className={` ${deviceType == "tablet" ? "w-[35px]" : "w-[30px]"
                    }`}
                />
              </div>
            )}
          </div>
          {/* )} */}
          {/* </div> */}
        </div>
        {(isOpenReplacePackageModal || isOpenAddPackageModal) && (
          <PackageItems
            onClose={() => {
              setIsOpenReplacePackageModal(false);
              setIsOpenAddPackageModal(false);
            }}
            packageItems={product?.packages}
            product={product}
            isAdd={isOpenAddPackageModal}
            changeProduct={() => {
              setDiscountType("");
              setDiscountValue("");
            }}
          />
        )}
        {editSPModalVisible && (
          <EditSPModal
            isVisible={editSPModalVisible}
            onCancel={() => seShowEditSPModalVisible(false)}
            onConfirm={(value) => {
              console.log("New SP:", value);
              onUpdateSP(product, value)
              // 👉 update product price here
              seShowEditSPModalVisible(false);
            }}
            product={product}
            deviceType={deviceType}
            i18n={i18n}
            t={t}
            AlphaNumericKeyboardModal={AlphaNumericKeyboardModal}
          />
        )}
      </>
    );
  },
);

export default ProductCart;
